<template>
  <span class="chat-rich" :class="{ compact }">
    <span v-for="(part, index) in parts" :key="index">
      <img
        v-if="part.type === 'emoji'"
        class="chat-rich-emoji"
        :src="part.src"
        alt="表情"
        draggable="false"
      />
      <template v-else>{{ part.text }}</template>
    </span>
  </span>
</template>

<script>
import { parseChatText } from '@/utils/chatEmoji'

export default {
  name: 'ChatRichText',
  props: {
    text: {
      type: String,
      default: ''
    },
    compact: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    parts() {
      return parseChatText(this.text)
    }
  }
}
</script>

<style lang="scss" scoped>
.chat-rich {
  white-space: inherit;
  word-break: inherit;
}

.chat-rich-emoji {
  width: 22px;
  height: 22px;
  margin: 0 1px;
  vertical-align: text-bottom;
  object-fit: contain;
  user-select: none;
}

.chat-rich.compact .chat-rich-emoji {
  width: 20px;
  height: 20px;
}
</style>
